module.exports = __webpack_public_path__ + "img/cerf13.de16a0d0.jpg";